declare module '@utils/http/response' {
	interface AppResponseList {
		'/restapi/v1/delete/notification/notice/recent': NotificationNoticeRecentResponse
	}
}

export const notificationNoticeRecentQueryKey = '@notification/notice/recent' as const

export type NotificationNoticeRecentResponse = CommonResponse<boolean>
